module.exports = __webpack_public_path__ + "static/img/bgphone-p20n.6d46a2e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/bgphone-p20n.png
// module id = cVQb
// module chunks = 1